export default {
  relevant: "绝不过时".toUpperCase(),
  always: "实时有效".toUpperCase(),
};
